<template>
  <div>
    <h2 :class="$style.title">
      <slot />

      <div
        v-if="required || optional"
        :class="$style.badge"
      >
        <Badge
          v-if="required"
          text="必填"
        />
        <Badge
          v-else-if="optional"
          text="選填"
          disabled
        />
      </div>
    </h2>

    <div :class="$style.text">
      <slot name="text" />
    </div>

    <div
      v-if="!noUnderline"
      :class="$style.line"
    />
  </div>
</template>

<style lang="scss" module>

.title {
  font-size: 28px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: #606060;
}

.badge {
  float: right;
}

.text {
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.7px;
  color: #484848;
  margin: 0;
  margin-top: 30px;

  a {
    color: #e73273;
    text-decoration: underline;
    font-weight: normal;
    cursor: pointer;
  }
}

.line {
  width: 100%;
  height: 1px;
  background-color: #bfbfbf;
  margin: 30px 0;
}
</style>

<script>
import Badge from '../others/Badge';

export default {
  components: {
    Badge,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    optional: {
      type: Boolean,
      default: false,
    },
    noUnderline: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
